export const ErrorViewGrid = {
  size: 100,
  gap: 0,
  name: "error_holder",
  padding: {
    top: 10,
    bottom: 20,
    // portrate: {
    //     left: 10,
    //     right: 10,
    // }
  },
  main: [
    {
      name: "errorgrid",
      size: 100,
      type: "PortrateGridController",
      config: {
        name: "errorgrid2",
        size: 100,
        gap: 0,
        main: [
          {
            name: "empty",
            size: 10,
          },
          {
            name: "error_img",
            size: 35,
            bounds: {
              width: 300,
              height: 220,
            },
            // height: 60,
            align: "bottom_center",
          },
          {
            name: "empty",
            size: 12,
          },
          {
            name: "error_info",
            size: 45,
            align: "top",
            height: 30,
          },
        ],
      },
    },
  ],
  landscape: [
    {
      name: "errorgrid-landscape",
      size: 100,
      type: "PortrateGridController",
      config: {
        name: "errorgrid2",
        size: 100,
        gap: 0,
        main: [
          {
            name: "empty",
            size: 11,
          },
          {
            name: "error_img",
            size: 30,
            bounds: {
              width: 610,
              height: 440,
            },
            // height: 60,
            align: "bottom_center",
          },
          {
            name: "empty",
            size: 27.5,
          },
          {
            name: "error_info",
            size: 45,
            align: "top",
            height: 30,
          },
        ],
      },
    },
  ],
  portrate: [
    {
      name: "empty",
      size: 20,
    },
    {
      name: "error_img",
      size: 25,
      bounds: {
        width: 610,
        height: 440,
      },
      // height: 60,
      align: "bottom_center",
    },
    {
      name: "empty",
      size: 23,
    },
    {
      name: "error_info",
      size: 40,
      align: "top",
      // height: 60,
    },
  ],
};
